import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const RegisterSucceeded = () => {
  const { state } = useLocation();
  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">登録完了しました。</Typography>
        <Typography variant="h5">名前：{state.name}</Typography>
        <Link to="/login">ログインはこちら</Link>
      </Box>
    </Container>
  );
};

export default RegisterSucceeded;
